import type { LucideIcon } from "lucide-react";
import { Bell, Settings, User } from "lucide-react";

/** An entry in the navigation. */
export interface NavItem {
  /** Must match a path registered in `routes.tsx`. */
  to: string;
  label: string;
  /** Shown in the user dropdown; the primary nav is text only. */
  icon?: LucideIcon;
}

/**
 * The primary navigation, in display order.
 *
 * An entry is added here by the same step that registers its route. Listing a screen before it
 * exists would put a dead link in the chrome of a live app, and "Page not found" is not a design.
 */
export const PRIMARY_NAV: NavItem[] = [
  { to: "/", label: "Home" },
  { to: "/pods", label: "Pods" },
  { to: "/calendar", label: "Calendar" },
  { to: "/notifications", label: "Notifications" },
];

/** Links in the user dropdown, below the identity block. Same rule as above. */
export const USER_MENU_NAV: NavItem[] = [
  { to: "/notifications", label: "Notifications", icon: Bell },
  { to: "/settings", label: "Settings", icon: Settings },
  { to: "/account", label: "Account", icon: User },
];
